/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const CompleteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M22.496 4.46302C22.3505 4.3163 22.1774 4.19985 21.9866 4.12038C21.7959 4.04091 21.5913 4 21.3846 4C21.178 4 20.9733 4.04091 20.7826 4.12038C20.5918 4.19985 20.4187 4.3163 20.2732 4.46302L8.61089 16.1403L3.71116 11.2252C3.56007 11.0792 3.3817 10.9645 3.18625 10.8874C2.9908 10.8104 2.7821 10.7727 2.57205 10.7763C2.362 10.7799 2.15473 10.8249 1.96206 10.9086C1.76939 10.9924 1.59511 11.1132 1.44915 11.2643C1.30319 11.4154 1.18843 11.5937 1.1114 11.7892C1.03438 11.9846 0.996605 12.1933 1.00024 12.4033C1.00387 12.6134 1.04884 12.8206 1.13258 13.0133C1.21632 13.206 1.33719 13.3802 1.48829 13.5262L7.49945 19.537C7.64497 19.6837 7.81811 19.8001 8.00887 19.8796C8.19963 19.9591 8.40423 20 8.61089 20C8.81754 20 9.02215 19.9591 9.21291 19.8796C9.40367 19.8001 9.5768 19.6837 9.72233 19.537L22.496 6.76403C22.6549 6.61745 22.7817 6.43955 22.8685 6.24154C22.9552 6.04352 23 5.8297 23 5.61352C23 5.39735 22.9552 5.18352 22.8685 4.98551C22.7817 4.7875 22.6549 4.6096 22.496 4.46302Z"
        fill="white"
      />
    </svg>
  )
}
